import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const getSaleDetail = async (params: object) => {
  return await GET({
    url: Api.getSaleDetail,
    params,
    headers: {
      rpcType: 'dubbo',
      'Client-Id': 'iss_courier',
      'Content-Type': 'application/json'
    },
    showError: false
  })
}
